import TicketNotification from './TicketNotification';
export default class TicketCreatedNotification extends TicketNotification {
  icon() {
    return 'fas fa-ticket';
  }
  content() {
    const guestName = this.guestName();
    return guestName ? this.trans('guest_ticket_created_text', {
      name: guestName
    }) : this.trans('ticket_created_text');
  }
}
flarum.reg.add('soup-97-support', 'forum/components/notifications/TicketCreatedNotification', TicketCreatedNotification);